//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"CirclePoint",1,"Point",0],[1,"Duration",0,"Expression",0],[0,"FlybyRank",1,0],[0,"Frame",1,"CoordinateSystem",0],[0,"MotionType",1,0],[0,"Name",1,0],[0,"SolutionIndex",1,0]],[[[],"GetSpeedData",{R_:{speedData:''}},0,0],[["speedData"],"SetSpeedData",{},1,0]],[]];
SPLM.Mechatronics.FrameBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.FrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.FrameBuilder.MotionTypes = Object.freeze({
    "Ptp" : "Ptp", "Linear" : "Linear", "Circular" : "Circular"});

export default SPLM;